/**
 * ReportsPage — route entry for the admin Operational Reports & Export module
 * (ODE-P07-T09). Applies the client-side permission mirror (`reports.view`,
 * UX only — the server-side OD-015 guard on every endpoint remains the
 * authority) and renders the module. Test seams are passed through (no real
 * fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-048, ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission } from '../../rbac/catalog.js';
import { ReportsModule, type ReportsSeams } from './ReportsModule.js';

export function ReportsPage({
  seams,
}: { readonly seams?: ReportsSeams } = {}): JSX.Element {
  const { session } = useAuth();
  const allowed = session !== null && hasPermission(session.staff.roles, 'reports.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin reports.view untuk halaman ini.',
        }}
      />
    );
  }
  return <ReportsModule seams={seams ?? {}} />;
}